import {StartComponent} from "../components";

export class StartComponentHelper {

    static getStartNodeOutputKey(nodeKey) {
        return `${nodeKey}_${StartComponent.START_COMPONENT_KEY}_${StartComponent.START_OUTPUT_KEY}`;
    }
}